(function () {
  function init() {
    var hero = document.querySelector(".qr-hero");
    if (!hero || hero.dataset.qrInit || !window.gsap) return;
    hero.dataset.qrInit = "true";

    var blob = hero.querySelector("[data-qr-blob]");

    var ctx = gsap.context(function () {
      gsap.fromTo(
        ".qr-hero-phone--primary",
        { y: 90, opacity: 0, rotate: -6 },
        { y: 0, opacity: 1, rotate: -4, duration: 1.3, delay: 0.5, ease: "power4.out" }
      );
      gsap.fromTo(
        ".qr-hero-phone--secondary",
        { y: 110, opacity: 0, rotate: 8 },
        { y: 0, opacity: 1, rotate: 5, duration: 1.3, delay: 0.7, ease: "power4.out" }
      );
      gsap.fromTo(
        ".qr-hero-chip, .qr-hero-qr",
        { y: 30, opacity: 0, scale: 0.8 },
        { y: 0, opacity: 1, scale: 1, duration: 1, delay: 1.2, stagger: 0.1, ease: "back.out(1.7)" }
      );

      gsap.to(".qr-hero-phone--primary", {
        y: "+=16",
        duration: 3.2,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        delay: 1.8,
      });
      gsap.to(".qr-hero-phone--secondary", {
        y: "+=20",
        duration: 3.8,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        delay: 2,
      });

      if (blob) {
        gsap.to(blob, { x: 40, y: -30, duration: 8, ease: "sine.inOut", yoyo: true, repeat: -1 });
      }

      gsap.to(".qr-hero-scroll-cue", {
        y: 8,
        duration: 1.1,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
      });
    }, hero);

    hero._qrCtx = ctx;
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
